export default () => ({
  code: '',
  update(event) {
    this.code = event.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()
  },
})
